/* eslint-disable react-hooks/exhaustive-deps */
import React, { Key, useState } from 'react';
import { TreeNode } from 'src/components/Tree/type';
import {
  Flex,
  Button,
  Icon,
  Link,
  useColorMode,
  useColorStyle,
  Text,
} from '@tonic-one/react';
import { AngleRightIcon } from '@tonic-one/react-icons';
import { Trans, useTranslation } from 'react-i18next';
import { useWhyDidYouUpdate } from 'src/utils/hooks';
import CasTreeTransfer, {
  TransferLeftBox,
} from 'src/components/CasTreeTransfer';
import TargetList from 'src/components/TargetList';
import CSpinner from 'src/components/CSpinner';
import { usePermissionStore } from '@Models/usePermissionModel';
import { PermissionNameEnum } from '@Types/permissions';
// import { Targets } from '@Policy/utils/types';

// export type SearchTargetResult = Pick<Targets, 'targets' | 'targetGroups'>;
export interface TargetUserGroupsProps {
  getAllTargets: (isPagination?: boolean) => Promise<void>;
  getSpecificTarget: (expandKeys: string[]) => Promise<void>;
  handleToRight: (keys: Key[]) => void;
  handleDeleteTarget: (key: Key) => void;
  syncTargets: (isPagination?: boolean) => Promise<void>;
  allTargets: TreeNode[];
  policyTarget: TreeNode[];
  searchTargetResult?: TreeNode[];
  searchTarget?: (value: string) => Promise<TreeNode[]>;
  isSyncButtonShow?: boolean;
  isSFObjectAndCommunities?: boolean;
}
export const TargetUserGroups = React.memo((props: TargetUserGroupsProps) => {
  const {
    getAllTargets,
    getSpecificTarget,
    handleToRight,
    handleDeleteTarget,
    syncTargets,
    allTargets,
    policyTarget,
    searchTarget,
    searchTargetResult,
    isSyncButtonShow = true,
  } = props;
  const { t } = useTranslation();
  // const isPagination = contextSelector(isPaginationSelector, isEqual);
  // local state
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const [checkedKeys, setCheckedKeys] = React.useState<Key[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const isBrightRight = React.useMemo(
    () => checkedKeys.length > 0,
    [checkedKeys]
  );
  // const defaultTargetsRef = React.useRef<Key[]>(
  //   policyTarget.map((t: TreeNode) => t.key)
  // );
  const handleExpand = React.useCallback(
    async (expandKeys: string[]) => {
      await getSpecificTarget(expandKeys);
    },
    [getSpecificTarget]
  );
  const handleCheckedKeysChange = React.useCallback((keys: Key[]) => {
    setCheckedKeys(keys);
  }, []);
  const handleToRightClick = React.useCallback(
    () => handleToRight(checkedKeys),
    [checkedKeys, handleToRight]
  );
  const handleSyncUser = React.useCallback(async () => {
    setLoading(true);
    await syncTargets(true);
    setCheckedKeys([]);
    setLoading(false);
  }, []);
  const showData = React.useMemo(() => {
    const isSearchResult = searchTargetResult
      ? searchTargetResult.length > 0
      : false;
    return isSearchResult ? searchTargetResult : allTargets;
  }, [allTargets, searchTargetResult]);
  const { widthEditablePermission } = usePermissionStore();
  useWhyDidYouUpdate('TargetUserGroups', {
    allTargets,
    policyTarget,
    checkedKeys,
    isBrightRight,
  });
  React.useEffect(() => {
    getAllTargets(true).then((r) => r);
  }, []);
  return (
    <Flex direction="column">
      {loading && <CSpinner />}
      <Flex alignItems="center" justify="space-between">
        {/* defaultValue always be [] for init. For new add policy, it will be [] naturally. For exised policy, some targets are not expanded in available targets, it will be not found, put these targets in defaultValue will cause an error  */}
        <CasTreeTransfer defaultValue={checkedKeys} isLeftOnly>
          <TransferLeftBox
            treeData={showData as TreeNode[]}
            onExpand={handleExpand}
            handleChange={handleCheckedKeysChange}
            onSearch={searchTarget}
          />
        </CasTreeTransfer>
        <Flex
          direction="column"
          alignItems="center"
          justifyContent="center"
          ml="12px"
          mr="12px"
          width="24px"
        >
          <Button
            variant="secondary"
            onClick={handleToRightClick}
            mb="8px"
            width="24px"
            size="sm"
          >
            <Icon
              as={AngleRightIcon}
              color={
                colorMode === 'dark'
                  ? isBrightRight
                    ? 'blue:50'
                    : 'white:primary'
                  : isBrightRight
                    ? 'blue:50'
                    : 'black:primary'
              }
            />
          </Button>
        </Flex>
        <TargetList
          title={t('policy.label.selectedTargets')}
          disabled={false}
          list={policyTarget}
          onDelete={handleDeleteTarget}
          limit={500}
          width="520px"
          size={9}
        />
      </Flex>
      {isSyncButtonShow && (
        <Flex mt="16px" whiteSpace="pre-wrap">
          <Text color={colorStyle.color.primary}>
            <Trans i18nKey="policy.text.generalDownClick">
              <Link
                onClick={handleSyncUser}
                disabled={
                  !(
                    widthEditablePermission(PermissionNameEnum.atpPolicy) ||
                    widthEditablePermission(PermissionNameEnum.dlpPolicy) ||
                    widthEditablePermission(PermissionNameEnum.administrator)
                  )
                }
              >
                placeholder
              </Link>
              placeholder
            </Trans>
          </Text>
        </Flex>
      )}
    </Flex>
  );
});
